export default __webpack_public_path__ + "static/the_immune_system-17d78ec7bb9010e3aa3c90b2feba8691.png";